import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { fetchOnBoardingCategories } from "@redux/actions";
import { isEmpty } from "lodash";

import CategoryTaskLayout from "@components/CategoryTask/CategoryTaskLayout";

const OnboardingCategories = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const categoryData = useSelector((state) => state.onboardCategories);

  useEffect(async () => {
    if (isEmpty(categoryData)) {
      setLoading(true);
      await dispatch(
        fetchOnBoardingCategories({ category_type: "onboarding" })
      );
      setLoading(false);
    }
  }, []);

  return (
    <>
      {loading ? (
        <Box
          display="flex"
          height={200}
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <CategoryTaskLayout
          categoryData={categoryData}
          transitionType={"onboarding"}
          loading={loading}
        />
      )}
    </>
  );
};

export default OnboardingCategories;
